import { showLoader, hideLoader } from "./loader";
import { loadVideo } from "./loadVideo";

export default function initFilter(formData) {
  const checkboxClass = ".js-filter_checkbox";
  const hubListClass = ".js-hub_list";
  const paginationDotClass = ".js-pagination_dot";
  const selectionItemClass = ".js-selection_item";
  const selectionRemoveClass = ".js-selection_remove";
  const selectionClearWrapClass = ".js-selection_clear_wrap";
  const hiddenClass = "m-hidden";

  const filterForm = document.querySelector(".js-filter_form");
  const filtersContainer = document.querySelector(".js-filter");
  const filterActionsRow = document.querySelector(".js-filter_actions");
  const filterSubmitBtn = document.querySelector(".js-filter_submit");
  const filterClearBtns = document.querySelectorAll(".js-filter_clear_all");
  const filterSearch = document.querySelector(".js-filter_search");
  const filterSearchBtn = document.querySelector(".js-filter_search_btn");
  const filterSearchSubmit = document.querySelector(".js-filter-search-submit");
  const filterSearchClearBtn = document.querySelector(
    ".js-filter_search_clear_btn",
  );
  const filterSearchCloseBtn = document.querySelector(
    ".js-filter_search_close_btn",
  );
  const filterSearchInput = document.querySelector(".js-filter_search_input");
  const filterSearchBtnText = document.querySelector(
    ".js-filter_search_btn_text",
  );
  const filterShow = document.querySelector(".js-show_filters");
  const pagination = document.querySelector(".js-pagination");
  const selections = document.querySelector(".js-selections");

  let pendingSelections = [];
  let appliedSearch = "";

  // External filter
  function getExternalFilterFromUrl() {
    const params = new URLSearchParams(window.location.search);

    const categoryId = params.get("filter-category");
    const value = params.get("filter-value");

    if (!categoryId || !value || value === "undefined") return null;

    return { categoryId, value };
  }

  function clearExternalFilterFromUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete("filter-category");
    url.searchParams.delete("filter-value");
    window.history.replaceState({}, "", url);
  }

  // Update formData values according to selection of checkboxes
  function updateData(categoryId, value, isChecked) {
    if (isChecked) {
      if (!formData[categoryId].includes(value)) {
        formData[categoryId].push(value);
      }
    } else {
      formData[categoryId] = formData[categoryId].filter((v) => v !== value);
    }
  }

  function scrollToFilters() {
    const headerHeight = document.querySelector(".js-header").offsetHeight;
    const top = filterForm.offsetTop - headerHeight;
    window.scrollTo(0, top);
  }

  // Toggle state of Submit/Clear all buttons according to existed selected checkboxes
  function updateActionButtons() {
    const hasAnySelection = Object.values(formData).some(
      (arr) => arr.length > 0,
    );

    if (hasAnySelection) {
      filterSubmitBtn.removeAttribute("disabled");
      filterSubmitBtn.setAttribute("type", "submit");
      filterClearBtns[0].removeAttribute("disabled");
    } else {
      filterSubmitBtn.setAttribute("disabled", "");
      filterSubmitBtn.setAttribute("type", "button");
      filterClearBtns[0].setAttribute("disabled", "");
    }
  }

  // Prepare data for sending to the server
  function getSerializedData() {
    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((arrayData) => {
          formDataToSend.append(key, arrayData);
        });
      } else formDataToSend.append(key, value);
    });

    return formDataToSend;
  }

  // Get updated markup and set to appropriate sections
  function updateView(page) {
    formData.search = filterSearchInput ? filterSearchInput.value.trim() : "";

    const ajaxUrl = filterForm.action;
    const hubList = document.querySelector(hubListClass);

    if (!hubList || !pagination) {
      return;
    }

    scrollToFilters();
    showLoader();

    const formDataToSend = getSerializedData();

    const serverAction = filterForm.dataset.serverAction || "";
    formDataToSend.append("action", serverAction);
    formDataToSend.append("page", page);

    fetch(ajaxUrl, {
      method: "POST",
      body: formDataToSend,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          hubList.innerHTML = data.data.html;
          pagination.innerHTML = data.data.pagination;
        }
      })
      .finally(() => {
        hideLoader();
        if (
          !pendingSelections.length ||
          pendingSelections.find(({ value }) => value === "video")
        ) {
          loadVideo();
        }
      });
  }

  function updatePendingSelections(value, isChecked, label) {
    if (isChecked) {
      pendingSelections.push({ value, label });
    } else {
      pendingSelections = pendingSelections.filter(
        (item) => item.value !== value,
      );
    }
  }

  function clearPendingSelections() {
    pendingSelections = [];
  }

  function updateSelectionsList(value, isChecked, label) {
    if (!selections) {
      return;
    }

    if (isChecked) {
      const selectionHtml = `
      <li class="b-selections-item js-selection_item" data-id="${value}">
        <span class="b-selections-item_label">${label}</span>
        <button type="button" class="b-selections-item_remove js-selection_remove"></button>
      </li>`;

      selections.insertAdjacentHTML("beforeend", selectionHtml);
    } else {
      selections
        .querySelector(selectionItemClass + `[data-id="${value}"]`)
        .remove();
    }
  }

  function updateSelectionsFromPending() {
    if (!selections) {
      return;
    }

    clearSelectionsList();

    pendingSelections.forEach(({ value, label }) => {
      updateSelectionsList(value, true, label);
    });

    // Show/hide selections block
    const hasAnySelection =
      selections.querySelectorAll(selectionItemClass).length > 0;
    selections.classList.toggle(hiddenClass, !hasAnySelection);
  }

  function clearSelectionsList() {
    const clearAllWrapper = selections.querySelector(selectionClearWrapClass);

    selections.innerHTML = "";
    selections.append(clearAllWrapper);
    selections.classList.add(hiddenClass);
  }

  function updateCategoryCountersFromApplied() {
    // reset all
    const categoryCounters = filterForm.querySelectorAll(".js-filter_counter");
    categoryCounters.forEach((counter) => {
      counter.textContent = "0";
      counter.classList.add(hiddenClass);
    });

    // count applied
    Object.entries(formData).forEach(([categoryId, values]) => {
      if (!Array.isArray(values) || values.length === 0) return;

      const counter = [...filterForm.querySelectorAll(".js-tab_trigger")]
        .find((el) => el.dataset.tabId === categoryId)
        ?.querySelector(".js-filter_counter");

      if (!counter) return;

      counter.textContent = values.length.toString();
      counter.classList.remove(hiddenClass);
    });
  }

  function clearAllCheckboxes() {
    // Reset Form data
    Object.keys(formData).forEach((key) => {
      formData[key] = [];
    });

    // Reset UI
    const activeCheckboxes = filtersContainer.querySelectorAll(
      checkboxClass + ":checked",
    );
    activeCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    //Reset counters
    const categoryCounters = filterForm.querySelectorAll(".js-filter_counter");
    categoryCounters.forEach((counter) => {
      counter.textContent = "0";
      counter.classList.add(hiddenClass);
    });

    updateActionButtons();
    clearPendingSelections();
    clearSelectionsList();
    updateView(1);
  }

  function closeTabs() {
    const activeTabTrigger = filterForm.querySelector(
      ".js-tab_trigger.m-active",
    );
    const activeTabContent = filterForm.querySelector(
      ".js-tab_content.m-active",
    );

    if (activeTabTrigger) {
      activeTabTrigger.classList.remove("m-active");
    }

    if (activeTabContent) {
      activeTabContent.classList.remove("m-active");
    }

    filterActionsRow.classList.add(hiddenClass);
  }

  // Apply filter from external link (e.g. "Explore all videos")
  function applyExternalFilter(categoryId, value) {
    // Clear all current filters
    Object.keys(formData).forEach((key) => {
      formData[key] = [];
    });

    // Apply required filter
    if (!formData[categoryId]) {
      formData[categoryId] = [];
    }

    // Reset all checkboxes
    const allCheckboxes = filtersContainer.querySelectorAll(checkboxClass);
    allCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Find required checkbox
    const checkbox = filtersContainer.querySelector(
      `${checkboxClass}[data-category-id="${categoryId}"][value="${value}"]`,
    );

    // Check checkbox
    checkbox.checked = true;

    const label = checkbox.dataset.label || value;

    // Apply data
    formData[categoryId] = [value];

    // Sync pending selections (required for tags)
    clearPendingSelections();
    pendingSelections.push({ value, label });

    // Reset UI state
    clearSelectionsList();
    updateSelectionsFromPending();
    updateCategoryCountersFromApplied();
    updateActionButtons();
    clearExternalFilterFromUrl();
    scrollToFilters();
  }

  function addEventListeners() {
    //Filter show
    filterShow.addEventListener("click", function () {
      filterForm.classList.toggle("m-filters_shown");

      if (!filterForm.classList.contains("m-filters_shown")) {
        if (selections.children.length > 1) {
          selections.classList.toggle(hiddenClass, false);
        }
      }
    });

    // Sublist checkbox selection handling
    filtersContainer.addEventListener("change", function (event) {
      const targetElement = event.target;

      if (targetElement.matches(checkboxClass)) {
        const categoryId = targetElement.dataset.categoryId;

        const value = targetElement.value;

        const isChecked = targetElement.checked;
        const label = targetElement.dataset.label;

        updateData(categoryId, value, isChecked);

        updatePendingSelections(value, isChecked, label);
        updateActionButtons();
      }
    });

    // Clear all button functionality handling
    filterClearBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        clearAllCheckboxes();
        closeTabs();
      });
    });

    // Form submit handling
    filterForm.addEventListener("submit", (event) => {
      event.preventDefault();
      closeTabs();
      filterSearch.classList.remove("m-active");
      appliedSearch = filterSearchInput.value.trim();
      updateSearchLabel();
      updateSelectionsFromPending();
      updateCategoryCountersFromApplied();
      updateView(1);
    });

    // Pagination functionality handling
    pagination.addEventListener("click", function (event) {
      event.preventDefault();

      const targetElement = event.target;

      if (targetElement.matches(paginationDotClass)) {
        const page = targetElement.dataset.page;

        updateView(page);
      }
    });

    // Selection removal handling
    selections.addEventListener("click", function (event) {
      const targetElement = event.target;

      // Remove selected item
      if (targetElement.matches(selectionRemoveClass)) {
        const selectionItem = targetElement.closest(selectionItemClass);
        const value = selectionItem.dataset.id;

        // remove from HTML
        selectionItem.remove();

        // uncheck checkbox
        const checkbox = filtersContainer.querySelector(
          checkboxClass + `[value="${value}"]`,
        );

        if (checkbox) {
          checkbox.checked = false;
        }

        // clear formData (applied state)
        Object.keys(formData).forEach((key) => {
          if (Array.isArray(formData[key])) {
            formData[key] = formData[key].filter((v) => v !== value);
          }
        });

        // clear pendingSelections
        pendingSelections = pendingSelections.filter(
          (item) => item.value !== value,
        );

        if (selections.children.length === 1) {
          selections.classList.toggle(hiddenClass, true);
        }

        updateActionButtons();
        updateSelectionsFromPending();
        updateCategoryCountersFromApplied();
        updateView(1);
      }
    });

    // Show/hide selections which depends on is any opened tabs is shown
    document.addEventListener("tabs:change", (e) => {
      let isShownSelections = e.detail.isAnyOpenTabs;

      filterActionsRow.classList.toggle(hiddenClass, !isShownSelections);

      // If only Clear All Filters is shown
      if (selections.children.length === 1) {
        isShownSelections = true;
      }

      if (e.detail) {
        selections.classList.toggle(hiddenClass, isShownSelections);
      }
    });

    // Filter search
    const disableSearchBtn = () => {
      filterSearchSubmit.setAttribute("disabled", "");
      filterSearchSubmit.setAttribute("type", "button");
      filterSearchClearBtn.classList.add(hiddenClass);
    };

    const visibleSearchActions = () => {
      filterSearchSubmit.removeAttribute("disabled");
      filterSearchSubmit.setAttribute("type", "submit");
      filterSearchClearBtn.classList.remove(hiddenClass);
    };

    const updateSearchBtnDisablingState = () => {
      if (filterSearchInput.value.trim() === "") {
        disableSearchBtn();
      } else {
        visibleSearchActions();
      }
    };

    filterSearchBtn.addEventListener("click", function () {
      closeTabs();
      filterForm.classList.toggle("m-filters_shown", false);

      filterSearch.classList.add("m-active");
      updateSearchBtnDisablingState();

      if (filterSearchInput) {
        filterSearchInput.focus();
      }
    });

    //Update Search Label
    const defaultText = filterSearchBtnText.textContent;

    const updateSearchLabel = () => {
      filterSearchBtnText.textContent =
        appliedSearch !== "" ? appliedSearch : defaultText;
    };

    updateSearchLabel();
    updateSearchBtnDisablingState();

    // Filter search input handling
    filterSearchInput.addEventListener("input", () => {
      updateSearchBtnDisablingState();
    });

    //Clear button in search handling
    filterSearchClearBtn.addEventListener("click", function () {
      filterSearchInput.value = "";
      appliedSearch = "";
      updateSearchLabel();
      updateSelectionsFromPending();
      updateCategoryCountersFromApplied();
      filterSearch.classList.remove("m-active");
      disableSearchBtn();
      updateView(1);
    });

    // Close button in search handling
    filterSearchCloseBtn.addEventListener("click", function () {
      filterSearch.classList.remove("m-active");
    });

    // // Explore all videos button handling
    // const exploreVideosBtn = document.querySelector(".js-filter-link");

    // if (exploreVideosBtn) {
    //   exploreVideosBtn.addEventListener("click", (event) => {
    //     event.preventDefault();

    //     const categoryId = exploreVideosBtn.dataset.filterCategory;
    //     const value = exploreVideosBtn.dataset.filterValue;

    //     applyExternalFilter(categoryId, value);
    //   });
    // }
  }

  addEventListeners();

  const externalFilter = getExternalFilterFromUrl();

  if (externalFilter) {
    applyExternalFilter(externalFilter.categoryId, externalFilter.value);
  }
}
